/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonAmmoLog,
    JsonAmmoLogFromJSON,
    JsonAmmoLogFromJSONTyped,
    JsonAmmoLogToJSON,
} from './JsonAmmoLog';

/**
 * 
 * @export
 * @interface ApiResultOfJsonAmmoLog
 */
export interface ApiResultOfJsonAmmoLog {
    /**
     * 
     * @type {JsonAmmoLog}
     * @memberof ApiResultOfJsonAmmoLog
     */
    data?: JsonAmmoLog;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAmmoLog
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonAmmoLog
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAmmoLog
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAmmoLog
     */
    result?: ApiResultOfJsonAmmoLogResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonAmmoLogResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonAmmoLogFromJSON(json: any): ApiResultOfJsonAmmoLog {
    return ApiResultOfJsonAmmoLogFromJSONTyped(json, false);
}

export function ApiResultOfJsonAmmoLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonAmmoLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonAmmoLogFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonAmmoLogToJSON(value?: ApiResultOfJsonAmmoLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonAmmoLogToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

